import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import Alert from "../components/Alert";
import AppBar from "../components/AppBar";
import Container from "../components/Container";
import Bibles from "./Bibles";
import BibleEdit from "./BibleEdit";
import Sites from "./Sites";
import SitesNew from "./SitesNew";
import SiteEdit from "./SiteEdit";

const App = ({ auth }) => {
  const { isAuthenticated, isAdmin } = auth;

  return (
    <div className="bg-gray-100 min-h-screen">
      <AppBar auth={auth} />

      {isAuthenticated() && isAdmin() && (
        <Container className="pb-12">
          <Switch>
            <Route path="/bibles/:bibleId" component={BibleEdit} />
            <Route path="/bibles" component={Bibles} />
            <Route path="/sites/new" component={SitesNew} />
            <Route path="/sites/:siteId" component={SiteEdit} />
            <Route path="/sites" component={Sites} />
            <Route exact path="/" render={() => <Redirect to="/sites" />} />
          </Switch>
        </Container>
      )}

      {!isAuthenticated() && (
        <div className="max-w-5xl px-4 mx-auto">
          <Alert color="primary">Please log in to view this page.</Alert>
        </div>
      )}

      {isAuthenticated() && !isAdmin() && (
        <div className="max-w-5xl px-4 mx-auto">
          <Alert color="primary">You do not have admin permissions</Alert>
        </div>
      )}
    </div>
  );
};

App.propTypes = {
  auth: PropTypes.shape({
    isAdmin: PropTypes.func,
    isAuthenticated: PropTypes.func
  }).isRequired
};

export default App;
